import { html, TemplateResult } from 'lit';
import type { Article } from '../article-cards.interface';
import type { CardRenderer, RendererConfig } from './article-cards.renderer';

/**
 * Renderer for the 'textHoriz' display format.
 * Compact list item — title link + date only.
 */
export class TextHorizRenderer implements CardRenderer {
  constructor(protected readonly config: RendererConfig) {}

  renderCard(article: Article, _index: number): TemplateResult {
    const { path, title, date } = article;
    const fullPath = `${path}.html`;

    return html`
      <li>
        <div>
          <h4 class="m-0 mt-2">
            <a class="link-dark" href="${fullPath}">${title}</a>
          </h4>
          <time class="m-0 mt-2">${date}</time>
        </div>
      </li>
    `;
  }

  renderSkeleton(): TemplateResult {
    return html`
      <li class="col article-skeleton">
        <div class="placeholder-glow">
          <span class="placeholder col-12 placeholder-lg d-block m-0 mt-2"></span>
          <span class="placeholder col-2 placeholder-lg d-block m-0 mt-3"></span>
          <span class="placeholder col-4 placeholder-sm d-block m-0 mt-2"></span>
        </div>
      </li>
    `;
  }

  getSkeletonCount(perRow: number, numRows: number): number {
    return perRow * numRows;
  }
}

/**
 * Renderer for the 'textVert' display format.
 */
export class TextVertRenderer extends TextHorizRenderer {
  override renderSkeleton(): TemplateResult {
    return html`
      <li class="col article-skeleton">
        <div class="border-bottom pb-3 mb-3 placeholder-glow">
          <span class="placeholder col-12 placeholder-lg d-block m-0 mt-2"></span>
          <span class="placeholder col-4 placeholder-sm d-block m-0 mt-2"></span>
        </div>
      </li>
    `;
  }
}
